import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog } from 'primereact/dialog';
import LiabilityRelease from './LiabilityRelease';

class LiabilityReleaseDialog extends Component {

  render() {

    const { open, toggle } = this.props;

    if (!open)
      return null;

    return (
      <Dialog 
        className="LiabilityReleaseDialog"
        visible={open}
        onHide={() => toggle(false)}
        header="Release of Liability and Participation"
      >
        <LiabilityRelease />
      </Dialog>
    )
  }
}

const mapStateToProps = (state) => {
  return {
  };
}

const mapDispatchToProps = dispatch => {
  return {
  };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(LiabilityReleaseDialog);